import React from 'react';
import AnMeetingBottomActionButtons from './anMeetingBottomActionButtons';

import AnMeetingDescriptionComponent from './anMeetingDescriptionComponent';
import AnMeetingRecipientsComponent from './anMeetingRecipientsComponent';
import AnMentorInfoComponent from './anMentorInfoComponent';

import './anSchedulingMeetingDetailsComponent.css';

const AnSchedulingMeetingDetailsComponent = ({
  areAllEmailsValid = true,
  showEditIcon = false,
  isEditIconClicked = false,
  isRecipientsListEditable = false,
  hideRecipientsList = false,
  bfiDto,
  currentUserId,
  editableNotes = '',
  editableTitle = '',
  extendedMentorDto = {},
  newRecipientEmail = '',
  recipients = [],
  showUpdateMeetingSpinner = false,
  onEditIconClicked = () => {},
  onSave = () => {},
  setEditableNotes = () => {},
  setEditableTitle = () => {},
  setRecipientEmail = () => {},
  addRecipientEmail = () => {},
  editRecipientEmail = () => {},
  removeRecipient = () => {},
}) => {
  return (
    <div className="et-an-smdc-meeting-details-wrap">
      <AnMentorInfoComponent
        displayName={extendedMentorDto.mentorDto.displayName}
        sessionTitle={extendedMentorDto.sessionTemplateDto?.sessionTitle}
        userProfileImage={extendedMentorDto.photoDto?.photoUrl}
      />
      <div className="et-an-smdc-desc-recipient-wrap">
        <AnMeetingDescriptionComponent
          isEditIconClicked={isEditIconClicked}
          showEditIcon={showEditIcon}
          meetingNotes={editableNotes}
          meetingTitle={editableTitle}
          onEditIconClicked={onEditIconClicked}
          setNotes={setEditableNotes}
          setTitle={setEditableTitle}
        />
        {!hideRecipientsList && (
          <AnMeetingRecipientsComponent
            areAllEmailsValid={areAllEmailsValid}
            isEditIconClicked={isRecipientsListEditable}
            currentUserId={currentUserId}
            newRecipientEmail={newRecipientEmail}
            recipients={recipients}
            requester={bfiDto.requester}
            setRecipientEmail={setRecipientEmail}
            addRecipientEmail={addRecipientEmail}
            editRecipientEmail={editRecipientEmail}
            removeRecipient={removeRecipient}
          />
        )}
      </div>
      {isEditIconClicked && (
        <div
          className={`et-an-anonymous-cancel-save-buttons-container ${
            !areAllEmailsValid || recipients.length === 0
              ? 'et-an-anonymous-erroneous-btn'
              : ''
          }`}>
          <AnMeetingBottomActionButtons
            showLeftBtn
            showRightBtn
            showSpinner={showUpdateMeetingSpinner}
            leftBtnTxt={'Cancel'}
            rightBtnTxt={'Save'}
            leftBtnFunc={onEditIconClicked}
            rightBtnFunc={onSave}
          />
        </div>
      )}
    </div>
  );
};

export default AnSchedulingMeetingDetailsComponent;
